export default __webpack_public_path__ + "static/media/number2.1eff4420.svg";